import VGModal from "../../../../../modules/vegas/js/modal";

window.dynamicTable = {
	lines: document.querySelectorAll('.dynamic-table table tbody tr'),

	init() {
		if(!this.lines.length) return;
		this.listeners();
	},

	listeners() {
		this.lines.forEach((el) => {
			this.mouseMove(el);
			this.mouseOut(el);
			this.clickElement(el);
			this.scrollMove(el)

			if(window.innerWidth < 991) {
				let position = el.offsetTop;
				let size = el.clientHeight
				el.style.setProperty('--position-tr', position + 'px')
				el.style.setProperty('--size', size + 'px')
			}

		})
	},

	generatedAttr(el, name, value) {
		el.setAttribute(name, value);
	},

	scrollMove(el) {
		const table = el?.closest('.dynamic-table');
		const scrollContainer = el?.closest('[data-scroll-container]');
		const offset = 24;
		if(!table || !scrollContainer) return;

		scrollContainer.addEventListener('touchmove', () => {
			if(scrollContainer.scrollLeft > table.clientWidth - offset) {
				el.style.setProperty('--opacity-after', 0);
			} else {
				el.style.setProperty('--opacity-after', 1);
			}
		})
	},

	mouseMove(el) {
		el.addEventListener('mouseenter', () => {
			const table = el.closest('.dynamic-table');
			const titleHover = table.getAttribute('data-table-title-hover') || 'Оставить заявку';

			this.generatedAttr(el, 'data-tr-title', titleHover);
		})
	},

	createElement(nameTag, title, value) {
		const elem = document.createElement(nameTag);
		if(title) {
			elem.insertAdjacentHTML('afterbegin', `<span>${title}</span>`)
		}
		if(value) {
			elem.insertAdjacentHTML('beforeend', `<span>${value}</span>`)
		}
		return elem;
	},

	clickElement(el) {
		el.addEventListener('click', () => {
			const table = el.closest('.dynamic-table');
			if(!table) return;
			const titleModal = table.getAttribute('data-table-title-modal') || 'Оставить заявку';
			const tableText = [...el.querySelectorAll('td')].map(el => ({value: el.textContent}));
			const listParams = document.querySelector('#modal-table .list-params');
			const data = [...table.querySelectorAll('thead th')]
				.map((el, index) => ({title: el.textContent, ...tableText[index]}))
				.filter(({title, value}) => !!value);

			VGModal.init('#modal-table', {
				'data-title': `${titleModal}`,
				'data-params': `${JSON.stringify(data)}`,
			});

			listParams.textContent = '';

			data.forEach(el => {
				listParams.append(this.createElement('li', el.title, el.value))
			})
		});
	},

	mouseOut(el) {
		el.addEventListener('mouseleave', () => {
			this.generatedAttr(el, 'data-tr-title', '')
		})
	}
}

window.dynamicTable.init();
